import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateSectionStyle } from "./createSectionStyle.request";

const useCreateSectionStyle = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateSectionStyle,
    ...options
  });
};

export default useCreateSectionStyle;
